import React from "react";
import { Center, Stack } from "@thecb/components";
import { Router } from "react-router";
import { History } from "history";
import { ThemeProvider } from "styled-components";
import theme from "../../theme";
import SharedAlertBar from "../alert-bar/POSAlertBar";
import { useClearAlertsOnPathChange } from "../../hooks";
import { isCreatePage, isEditPage } from "../../util";

type Props = {
  history: History;
  children?: JSX.Element;
};

const POSConfigToolContainer = ({
  history,
  children = <></>,
}: Props): JSX.Element => {
  useClearAlertsOnPathChange(history);
  return (
    <ThemeProvider theme={theme}>
      <Router history={history}>
        <Center
          maxWidth={
            isCreatePage(history.location) || isEditPage(history.location)
              ? "700px"
              : "1258px"
          }
        >
          <SharedAlertBar isToast={false} showQuitLink />
          <Stack>{children && children}</Stack>
        </Center>
      </Router>
    </ThemeProvider>
  );
};

export default POSConfigToolContainer;
